





























import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice, IVW } from '@/types/model'
import RadioIcon from '@/components/RadioIcon.vue'
import VwPreviewScreen from '@/components/VwPreviewScreen.vue'
import EnableIndicator from '@/components/EnableIndicator.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'
import { thumb_size_t } from '@/store/modules/pref'

export default Vue.extend({
  components: {
    VwPreviewScreen,
    RadioIcon,
    EnableIndicator
  },
  props: {
    /** Currently chosen in this radio group. Use v-model to access this. */
    vw: {
      type: Object
    } as PropValidator<IVW>
  },
  computed: {
    thumbSize (): thumb_size_t { return this.$s.$state.pref.vw.thumbSize }
  },
  methods: {
    openVwRenameDialog () { this.$router.push({ name: 'vwlst_rename', params: { vwid: this.vw.id + '' }}) },
    openVwDetailsDialog () { this.$router.push({ name: 'vwlst_details', params: { vwid: this.vw.id + '' }}) },
    openVwDeleteDialog () { this.$router.push({ name: 'vwlst_delete', params: { vwid: this.vw.id + '' }}) },
    applyThisVw () { easyapi.applyVw(this.vw.id) },
  }
})
